import styled from 'styled-components'

import { Colors, FontSize } from '~/styles'

const Main = styled.main`
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`

const Section = styled.section`
  width: 100%;
  display: flex;
  padding: 24px;
  justify-content: space-between;
`

const SectionTitle = styled.h1`
  width: 50%;
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${Colors.softBlack};
`

const DropdownContainer = styled.div`
  gap: 24px;
  width: 50%;
  position: relative;
  display: flex;
  justify-content: flex-end;
`

const CurrentDateContainer = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
`

const CalendarIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: cover;
`
const CurrentDateText = styled.span`
  font-size: ${FontSize.medium};
  font-weight: 600;
  color: ${Colors.softBlack};
`

const DashboardContainer = styled.section`
  gap: 24px;
  width: 100%;
  display: grid;
  padding: 0 24px;
  height: calc(100vh - 187px);
  align-items: flex-start;
  justify-items: center;
  grid-template-columns: repeat(2, 1fr);
`

const DashboardSection = styled.section`
  gap: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
`

const TrafficTitle = styled.h2`
  color: ${Colors.tealBlue};
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
`

const CardContainer = styled.div`
  gap: 16px;
  width: 100%;
  height: calc((115px * 5) + (16px * 5));
  display: flex;
  overflow-y: auto;
  flex-direction: column;
`

const CardScrollWrapper = styled.div`
  height: calc((115px * 5) + (16px * 5));
  overflow: hidden;
  position: relative;

  &:hover .scrolling-content {
    animation-play-state: paused;
  }
`

const ScrollingContent = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
  animation: scroll-up 20s linear infinite;
  animation-play-state: running;

  @keyframes scroll-up {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(-50%);
    }
  }
`


export default {
  Main,
  Section,
  SectionTitle,
  CalendarIcon,
  TrafficTitle,
  CardContainer,
  CurrentDateText,
  DashboardSection,
  ScrollingContent,
  DropdownContainer,
  CardScrollWrapper,
  DashboardContainer,
  CurrentDateContainer,
}